export default "__VITE_ASSET__3zBIoZel__"